/* eslint-disable consistent-return */
/* eslint-disable no-unused-vars */
import React, { memo, useEffect } from 'react';
import { NavLink, useHistory, useParams } from 'react-router-dom';
import './css/NavBar.css';
import { ButtonType } from '../buttons/ButtonType.ts';
import NavItems from './NavItems';
import DropDownNavItems from './DropDownNavItems';
import OptimxGreenIcon from '../../../assets/icons/optimxGreenIcon.png';
import OptimxNameIcon from '../../../assets/icons/optimxNameIcon.png';
import { referralPrice } from '../../../catalog/Others';

const NavBar2 = () => {
    const history = useHistory();
    const params = useParams();

    const PORTAL_URL_SEGMENTS = ['portal'];

    useEffect(() => {
    }, [history, params]);

    const firstSegment = history.location.pathname.split('/')[1];

    return (
        <>
            {PORTAL_URL_SEGMENTS.includes(firstSegment) ? (
                <div className="navbar-container2">
                    <div className="m-t-10px" onClick={() => { history.push('/portal/store'); }}>
                        <p className="text-uppercase x-center font-weight-800 m-t-0 m-b-0">Now sell merchandise, tickets and collect dues. Click Here to start!</p>
                    </div>
                </div>
            ) : null}
        </>
    );
};

export default memo(NavBar2);
